import { useCoins } from "@contexts/CoinsContext"

type Props = {
    amount: number,
    coinId: string
    size?: "md" | "sm",
    isSelected?: boolean,
    onSelected?: (coinId: string) => void
}

export function SelectableCoinBadge({ amount, coinId, size = 'md', isSelected = false, onSelected }: Props) {
    const { getCoin } = useCoins()

    const coin = getCoin(coinId ?? "")

    return <button
        onClick={() => onSelected?.(coinId)}
        className={`group inline-flex items-center rounded-lg border text-white ${isSelected ? "bg-jacarta-500 border-transparent" : "bg-jacarta-800 border-jacarta-500"} ${size === "sm" ? "px-3 py-2" : "px-4 py-3"}`}>
        <img src={coin?.icon ?? "/src/img/coins/gold.svg"} className={`${size === "sm" ? "mr-1 h-3 w-3" : "mr-2 h-4 w-4"} fill-jacarta-700 group-hover:fill-white dark:fill-white`} alt="" />
        <span className={`${size === "sm" ? "text-xs" : "text-2xs"} font-medium`}>{(amount / Math.pow(10, coin?.decimals ?? 6)).toLocaleString()} {coin?.name}</span>
    </button>
}